import styled from 'styled-components';
import {theme} from '@styles/theme';

export const AvatarWrapper = styled.div<{size?: number; systemOwner?: boolean}>`
  position: relative;
  width: ${({size}) => (size ? `${size}px` : '32px')};
  height: ${({size}) => (size ? `${size}px` : '32px')};
  border: 0;
  border-radius: ${({size}) => (size ? `${size}px` : '32px')};
  background: ${({systemOwner}) =>
    systemOwner ? theme.colors.signalGreen00 : theme.colors.basic06};
`;

export const AvatarWrapperBG = styled.div<{size?: number; systemOwner?: boolean}>`
  content: '';
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 1px;
  left: 1px;
  width: ${({size}) => (size ? `${size - 4}px` : '26px')};
  height: ${({size}) => (size ? `${size - 4}px` : '26px')};
  padding: 1px;
  border: 0;
  border-radius: ${({size}) => (size ? `${size}px` : '30px')};
  background: ${({systemOwner}) =>
    systemOwner ? theme.colors.signalGreen01 : theme.colors.basic08};  
  img {
    width: ${({systemOwner, size}) =>
      systemOwner ? (size ? `${size - 6}px` : '26px') : size ? `${size - 4}px` : '28px'};
    height: ${({systemOwner, size}) =>
      systemOwner ? (size ? `${size - 6}px` : '26px') : size ? `${size - 4}px` : '28px'};
    border-radius: ${({size}) => (size ? `${size}px` : '30px')};
    background: ${({systemOwner}) =>
      systemOwner ? theme.colors.basic08 : 'transparent'};
  }
`;
